import { useMemo } from 'react';
import { getSignInUrl } from '@ankr.com/auth';

import { AUTH_APP_ID, AUTH_APP_PATH, AUTH_SERVICE_PATH } from '../const';
import { useAuth } from './useAuth';

export const useSSOAuth = () => {
  const { isSignedIn } = useAuth();

  const signInUrl = useMemo(
    () =>
      getSignInUrl({
        authPath: AUTH_SERVICE_PATH,
        appPath: AUTH_APP_PATH || window.location.host,
        appId: AUTH_APP_ID,
        referrer: window.location.href,
      }),
    [],
  );

  const handleSignIn = () => {
    window.location.assign(signInUrl);
  };

  return { handleSignIn, isSignedIn, signInUrl };
};
